import React, { useState } from 'react';
import {
  Breadcrumb, Button, Input, Card, Table, Spin, Row, Col, Select
} from 'antd';
import { useTranslation } from 'react-i18next';
import { faMicrochip, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FallOutlined, RiseOutlined } from '@ant-design/icons';
import Chart from 'react-apexcharts';
import {
  ResponsiveContainer,
} from 'recharts';

import MainLayout from '@common/layouts/MainLayout';
import withAuth from '@common/hocs/withAuth'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
 
import Map from '@common/components/map/GoogleMap';
import invertesIcon from '@assets/img/markers/convertidor/icon-inverters.png';
import {
  InfoWindow, Marker,
} from '@react-google-maps/api';

import useClientesDetail from './useClientesDetail';
import styles from './ClientesDetail.module.less';

import { ReactComponent as companyIcon } from '@assets/svg/company.svg'; 
import Icon from '@ant-design/icons/lib/components/Icon';

function ClientesDetail() {

  const { t } = useTranslation();
  const {
    loading,
    dataSource,
    columns,
    optionsGraphG1,
    seriesGraphG1,
    optionsGraphG2,
    seriesGraphG2,


    clientD,
    devicesD,
    businessTypeD,
    viewDashboard

  } = useClientesDetail();
 
  const [activeMarker, setActiveMarker] = useState(null);
  const handleActiveMarker = (marker) => { 
    if (marker === activeMarker) { 
      return; 
    }
    setActiveMarker(marker); 
  };

  return (
    <MainLayout applyWidthLimit>
      <ResponsiveContainer> 
        <div className={styles.wrapper}>
          <div className={styles.fields_wrapper} />

          {
            loading?
              <Row style={{
                width: '100%', magin: 'auto', display: 'flex', justifyContent: 'center', justifyItems: 'center',
              }}>
                <Col style={{ justifyContent: 'center', marginTop: '5%' }}>
                  <Spin tip={t('views.device_graphics.loading_data_graphs')} />
                </Col>
              </Row>
            :
              <div>
                <div className={styles.fields_wrapper} />
                <Row gutter={[16, 8]}>
                  <Col xs={{span: 24}} sm={{span: 24}} md={{span: 12}} lg={{span: 12}} xl={{span: 12}}
                  >
                      <div style={{
                        background: '#fff',
                        padding: 25,
                        minHeight: '320px',
                        height: 'fit-content',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center', 
                      }}>
                        <div style={{ /* Remove unnecessary `justifyContent` property */ }}>
                          <Row gutter={[16, 8]} style={{ fontSize: 20, fontWeight: 'bold', marginBottom: 10 }}>
                            <Col span={8} className="text-right" style={{ color: '#8c8c8c', fontSize: 24, fontWeight: 'bold' }}>
                              <div className={styles.circle_icon_container}>
                                <Icon component={companyIcon} style={{ fontSize: 40, fill: 'red' }} />
                              </div>
                            </Col>
                            <Col span={16}>
                              <Row style={{ color: '#8c8c8c', fontSize: 24, fontWeight: 'bold' }}>
                               {clientD?.celsia_id || ''}
                              </Row>
                              <Row style={{ fontSize: '14px', color: '#8c8c8c' }}>
                                <Breadcrumb className="date_wrapper">
                                  <Breadcrumb.Item className="breadcrumb">
                                    <Link to="/">{t('menu_items.main.home')}</Link>
                                  </Breadcrumb.Item>


                                  {viewDashboard && businessTypeD?.id &&
                                    <Breadcrumb.Item className="breadcrumb">
                                      <Link to={`/tablero-comunidades/${businessTypeD?.id?.toString()}`}>{businessTypeD?.name || ''}</Link>
                                    </Breadcrumb.Item>
                                  }

                                  {!viewDashboard &&
                                    <Breadcrumb.Item className="breadcrumb">
                                      <Link to="/clientes">{t('views.users.breadcrumb.clients')}</Link>
                                    </Breadcrumb.Item>
                                  }
                                  
                                  <Breadcrumb.Item className="breadcrumb">
                                    {clientD?.celsia_id || ''}
                                  </Breadcrumb.Item>
                                </Breadcrumb>
                              </Row>
                            </Col>
                          </Row>
                          <p className="text-center" style={{ color: '#8c8c8c',minWidth: '500px'}}>
                           {clientD?.description || ''}
                          </p>
                          <div className="text-center" style={{ padding: 10, borderRadius: 10, textAlign: 'center' }}>
                            <span style={{ fontSize: 14, fontWeight: 'bold', margin: '0 0.5rem' }}>
                              {t('forms.users.labels.business_line')}:
                              {' '}
                              {businessTypeD?.name || ''}
                            </span>
                            <span style={{ fontSize: 14, fontWeight: 'bold', margin: '0 0.5rem' }}>
                              {t('forms.clients.labels.id_tercero')}:
                              {' '}
                              {clientD?.third_id || ''}
                            </span><br></br>
                            <span style={{ fontSize: 14, fontWeight: 'bold', margin: '0 0.5rem' }}>
                              {t('forms.clients.labels.estrato')}:
                              {' '}
                              {clientD?.stratum || ''}
                            </span> 
                            <span style={{ fontSize: 14, fontWeight: 'bold', margin: '0 0.5rem' }}>
                              {t('forms.clients.labels.community_rep')}:
                              {' '}
                              {clientD?.representative?t("common.yes"):"No"}
                            </span> 
                          </div>
                        </div>
                      </div>
          
                  </Col> 
          
                  <Col xs={{span: 24}} sm={{span: 24}} md={{span: 12}} lg={{span: 12}} xl={{span: 12}}
                  >
                    <div style={{  background: '#fff', padding: 25, minHeight: '320px', height: 'fit-content'  }}
                    >
                      <div className="container_map" style={{height:'260px'}}>
                        <Map>
                          <>
                            {businessTypeD?.latitude && businessTypeD?.longitude  &&
                              <Marker
                                key={businessTypeD.id}
                                icon={{
                                  url: invertesIcon, 
                                }}
                                position={{ lat:businessTypeD?.latitude, lng: businessTypeD?.longitude }}  
                                onClick={() => handleActiveMarker(businessTypeD.id)}
                              >
                                {activeMarker === businessTypeD.id ? (  
                                  <InfoWindow onCloseClick={() => setActiveMarker(null)} options={{ maxWidth: 320 }}>
                                    <div>
                                      <h4>{businessTypeD?.name} </h4> 
                                    </div>
                                  </InfoWindow> 
                                ) : null}
                              </Marker>
                            }
                          </>
                        </Map>
                      </div>
                    </div>
                  </Col>
                </Row>
          
                <Row gutter={[16, 8]}>
                  <Col span={24}>
                    <Row>
                      <Card className={styles.tables}>
                        <ResponsiveContainer width="100%">
                          <div className={styles.tables}>
                            <Row className={styles.headerTables} gutter={[8, 8]}>
          
                              <Col xs={{span: 24,order: 1, }} sm={{span: 24,order: 1, }} md={{span: 14,order: 2, }} lg={{span: 14,order: 2, }} xl={{span: 14,order: 2, }}
                              >
                                <Input
                                  placeholder={t('common.find')}
                                  className={styles.search} 
                                  // onChange={onChangeSearch}
                                  suffix={<FontAwesomeIcon icon={faSearch} />}
                                  allowClear
                                />
                              </Col> 
          
                              <Col
                                className="select-filter"
                                xs={{ span: 24, order: 2}} sm={{ span: 24, order: 2}} md={{ span: 6, order: 3}} lg={{ span: 6, order: 3}} xl={{ span: 6, order: 3}}
                              >
                                <Select
                                  defaultValue="todos"
                                  className={styles.select_device} 
                                  options={[
                                    {
                                      value: 'todos',
                                      label: t('common.show_all'),
                                    },
                                    {
                                      value: 'conectados',
                                      label: t('common.connected'),
                                    },
                                    {
                                      value: 'desconectados',
                                      label: t('common.disconnected'),
                                    },
                                  ]}
                                />
                              </Col> 
          
                              <Col
                                xs={{
                                  span: 24,
                                  order: 4,
                                }}
                                sm={{
                                  span: 24,
                                  order: 4,
                                }}
                                md={{
                                  span: 4,
                                  order: 4,
                                }}
                                lg={{
                                  span: 4,
                                  order: 4,
                                }}
                                xl={{
                                  span: 4,
                                  order: 4,
                                }}
                              >
                                <Button type="primary" className={styles.btn_create}  >
                                  Generar reporte
                                </Button>
                              </Col>
          
                            </Row>
                          </div>
                        </ResponsiveContainer>
                      </Card>
                    </Row>
                    
                    <Row gutter={[16, 8]}>
                      <Col span={24} >
                        <Card style={{ width: '100%',marginTop:6 }}>
          
                          <Row>
                            <Col span={24}>
                              <span className='miga_title' style={{fontSize:18}}>Resumen</span> <span className={styles.cardText}>Total acumulado</span> 
                            </Col>
                          </Row>
          
                          <Row>
                            
                            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                              <div className={styles.cardCustom}>
                                <RiseOutlined  style={{fontSize:25, color:'#ff812e'}} /> <span className='miga_title'>420.000</span> <span className={styles.cardText}>kwh</span><br></br>
                                <span>Energía solar generada</span>
                              </div>
                            </Col>
          
                            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                            <div className={styles.cardCustom}>
                                <FallOutlined  style={{fontSize:25, color:'#39587d'}} /> <span className='miga_title'>284.430</span> <span className={styles.cardText}>kwh</span><br></br>
                                <span>Energía Consumida</span>
                              </div>
                            </Col>
          
                            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                              <div className={styles.cardCustom}>
                                <RiseOutlined  style={{fontSize:25, color:'#ff812e'}} /> <span className='miga_title'>135.570</span> <span className={styles.cardText}>kwh</span><br></br>
                                <span>Energía solar reservada</span>
                              </div>
                            </Col>
                            
                          </Row>
          
                          <Row>
                            
                            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                              <div className={styles.cardCustom}>
                                <RiseOutlined  style={{fontSize:25, color:'#ff812e'}} /> <span className='miga_title'>753.400.403</span> <span className={styles.cardText}>cop</span><br></br>
                                <span>Ganancias generadas</span>
                              </div>
                            </Col>
          
                            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                            <div className={styles.cardCustom}>
                                <span className='miga_title'>12.78</span> <span className={styles.cardText}>ton</span><br></br>
                                <span>Total C02 reducido</span>
                              </div>
                            </Col>
          
                            <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                              <div className={styles.cardCustom}>
                                <span className='miga_title'>12</span> <span className={styles.cardText}></span><br></br>
                                <span>Total dispositivos </span>
                              </div>
                            </Col>
                            
                          </Row>
                        </Card>
                      </Col>
                    </Row>
          
                    <Row gutter={[16, 8]}>
                      <Col span={24} >
                        <Card style={{ width: '100%' }}>
          
                          <Row>
                            <Col span={24}>
                              <span className='miga_title' style={{fontSize:18}}>Tabla de liquidaciones</span> 
                            </Col>
                          </Row> 
          
                          <Row> 
                            <Col span={24}>
                              <Table dataSource={dataSource} columns={columns} width={'100%'} />
                            </Col>
                          </Row>
                        </Card>
                      </Col>
                    </Row>
          
                    <Row gutter={[16, 8]}>
                      <Col span={12}>
                        <Card style={{ width: '100%' }}>
          
                          <Row>
                            <Col span={24}>
                              <span className='miga_title' style={{fontSize:18}}>Energía solar generada VS consumida</span> 
                            </Col>
                          </Row> 
          
                          <Row> 
                            <Col span={24}>
                              <Chart
                                  className="container-graph-third"
                                  options={optionsGraphG1}
                                  series={seriesGraphG1}
                                  height={370}
                                  width="100%"
                                  type="donut"
                                />
                            </Col>
                          </Row>
                        </Card>
                      </Col>
          
                      <Col span={12}>
                        <Card style={{ width: '100%' }}>
          
                          <Row>
                            <Col span={24}>
                              <span className='miga_title' style={{fontSize:18}}>Energía solar generada</span> 
                            </Col>
                          </Row> 
          
                          <Row> 
                            <Col span={24}>
                              <Chart
                                className="container-graph-third"
                                options={optionsGraphG2}
                                series={seriesGraphG2}
                                width="100%"
                                type="area"
                              />
                            </Col>
                          </Row>
                        </Card>
                      </Col>
          
                    </Row>
                  
          
                  </Col>
                </Row>
              </div>
          }

         
           

        </div>
      </ResponsiveContainer>
    </MainLayout>
  );

}

export default withAuth(ClientesDetail);
